/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WelcomePingRequest interface.
 */
export function instanceOfWelcomePingRequest(value) {
    if (!('visitToken' in value) || value['visitToken'] === undefined)
        return false;
    return true;
}
export function WelcomePingRequestFromJSON(json) {
    return WelcomePingRequestFromJSONTyped(json, false);
}
export function WelcomePingRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'src': json['src'] == null ? undefined : json['src'],
        'visitToken': json['visit_token'],
    };
}
export function WelcomePingRequestToJSON(json) {
    return WelcomePingRequestToJSONTyped(json, false);
}
export function WelcomePingRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'src': value['src'],
        'visit_token': value['visitToken'],
    };
}
